import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { setAuditLockTransaction } from '../../redux/modules/auth';
import { getAuditLockTransactions } from '../../api/auditLock';

const useAuditLockTransactionModule = () => {
  const dispatch = useDispatch();
  const { isAuthed } = useSelector(({ auth }) => auth);

  useEffect(() => {
    if (isAuthed) {
      loadData();
    }
  }, []);

  const loadData = async () => {
    try {
      const res = await getAuditLockTransactions();

      const { code, result } = res.data.response;

      if (code !== '00000') {
        toast.error(result);
        return;
      }

      dispatch(setAuditLockTransaction(result));
    } catch (error) {
      toast.error(error.message);
    }
  };

  const refetchAuditLockTransactionModule = () => {
    loadData();
  };

  return {
    refetchAuditLockTransactionModule,
  };
};

export default useAuditLockTransactionModule;
